import { Box } from 'src/components/UI/Box';
import { Flex } from 'src/components/UI/Flex';
import { Checkbox } from 'src/components/UI/Checkbox';

interface CustomCheckboxProps {
  isChecked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
}

export function CustomCheckbox({ isChecked, onChange, label, description }: CustomCheckboxProps) {
  return (
    <Box
      border="1px solid"
      borderColor={isChecked ? 'primary.900' : 'gray.300'}
      borderRadius="12px"
      p="20px"
      cursor="pointer"
      transition="all 0.2s"
      bg={isChecked ? 'primary.900' : 'white'}
      _hover={{ borderColor: isChecked ? 'primary.900' : 'gray.400' }}
      onClick={(e) => {
        const target = e.target as HTMLElement;
        const isCheckboxClick = target.tagName === 'INPUT' || target.closest('.chakra-checkbox') !== null;
        if (!isCheckboxClick) {
          onChange(!isChecked);
        }
      }}
    >
      <Flex alignItems="center" gap="12px">
        <Checkbox
          isChecked={isChecked}
          onChange={(e) => {
            onChange(e.target.checked);
          }}
          size="md"
          colorScheme="primary"
          sx={{
            '.chakra-checkbox__control': {
              borderColor: isChecked ? 'secondary.500' : 'gray.300',
              bg: isChecked ? 'secondary.500' : 'transparent',
              _checked: {
                bg: 'secondary.500',
                borderColor: 'secondary.500',
                _hover: {
                  bg: 'secondary.500',
                  borderColor: 'secondary.500',
                },
              },
            },
            '.chakra-checkbox__icon': {
              color: isChecked ? 'white' : 'transparent',
            },
          }}
        />
        <Box flex="1">
          <Box
            as={'span'}
            fontFamily={'Ambit'}
            fontSize="14px"
            fontWeight="600"
            color={isChecked ? 'white' : 'primary.1000'}
          >
            {label}
          </Box>
          {description && (
            <Box
              mt="4px"
              fontFamily={'Ambit'}
              fontSize="14px"
              fontWeight="700"
              color={isChecked ? 'white' : 'primary.main'}
            >
              {description}
            </Box>
          )}
        </Box>
      </Flex>
    </Box>
  );
}
